import axios from 'axios';
import { JobBoardSettingsDto, JobDto } from '../types/jobBoard';
import { JOBBOARD_API_BASE_URL } from './apiConfig';

const api = axios.create();
const API_BASE = `${JOBBOARD_API_BASE_URL}/api/public/job-board`;

export const publicJobBoardApi = {
  getSettings: (slug: string) => api.get<JobBoardSettingsDto>(`${API_BASE}/${slug}`),
  getJobs: (slug: string) => api.get<JobDto[]>(`${API_BASE}/${slug}/jobs`),
  getJob: (slug: string, jobId: string) => api.get<JobDto>(`${API_BASE}/${slug}/jobs/${jobId}`),
};

export const PublicJobBoardApi = publicJobBoardApi;